// Shared CTA blocks used at the end of every Insights guide.
// Kept in a separate module so article files can import them without a
// circular dependency on the ARTICLES index.

export const ctaPl = {
  eyebrow: "Następny krok",
  title: "Potrzebujesz tych danych dla swojej roli?",
  body: "Napisz, jakiej technologii, poziomu doświadczenia i lokalizacji dotyczy rekrutacja, a wrócimy z rzetelnym odczytem rynku: widełki wynagrodzeń, dostępna pula kandydatów i przewidywany czas do oferty. Bez zobowiązań, zwykle w ciągu doby.",
  primary: "Poproś o odczyt rynku",
  secondary: "Zobacz Fit-to-Win Sprint",
};

export const ctaEn = {
  eyebrow: "Next move",
  title: "Want this data for your exact role?",
  body: "Send us the stack, seniority and location and we will come back with a live market read: realistic range, available talent pool and expected time to offer. No obligation, usually within 24 hours.",
  primary: "Request a market read",
  secondary: "See the Fit-to-Win Sprint",
};

export const ctaZh = {
  eyebrow: "下一步",
  title: "想获取针对你具体岗位的数据吗？",
  body: "告诉我们技术栈、级别和地点,我们会给出实时市场判断:合理的薪资区间、可用候选人池和预计发offer所需时间。无需承诺,通常24小时内回复。",
  primary: "获取市场判断",
  secondary: "了解 Fit-to-Win Sprint",
};
